import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { HeroSection } from "./hero";
import { DesktopPartners } from "./partners/DesktopPartners";
import { MobilePartners } from "./partners/MobilePartners";
import { WhoWeServeSection } from "./whoWeServe";
import { OurServicesSection } from "./ourServices";
import { InsightsSection } from "./insights";
import { WhyPrecisionSection } from "./whyPrecision";
import { CustomersSaySection } from "./customersSay";

const HomeUI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
      offset: 100,
      easing: "ease-in-out",
      once: true,
    });
    AOS.refresh();
  }, []);

  const handleTalkToTeam = () => {
    window.open("https://calendly.com/precisionmatch/product-demo", "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-white overflow-x-hidden">
      <HeroSection onTalkToTeam={handleTalkToTeam} />
      <WhoWeServeSection />
      <OurServicesSection />
      <InsightsSection />
      <WhyPrecisionSection />
      <DesktopPartners />
      <MobilePartners />
      <CustomersSaySection />
    </div>
  );
};

export { HomeUI };
